// extracted by mini-css-extract-plugin
module.exports =  {"content":"_93444fe79c--content--fK8Db","wide":"_93444fe79c--wide--gdMrS"};